import { render, staticRenderFns } from "./Medicamentos.vue?vue&type=template&id=0484f3a8&scoped=true&"
import script from "./Medicamentos.vue?vue&type=script&lang=js&"
export * from "./Medicamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484f3a8",
  null
  
)

export default component.exports